<template>
  <div class="ma-2">
      <v-card flat tile @mouseover="showOverlay =! showOverlay" @mouseout="showOverlay =! showOverlay">
        <v-img  class="white--text align-center pa-4 box" :src="item.src" :lazy-src="item.src" aspect-ratio="1.4" @click="show = !show">
          <v-btn text block class="white--text" :href="item.url"><v-icon x-large>{{item.title}}</v-icon></v-btn>
        </v-img>
      </v-card>
</div>
</template>
<script>
export default
{
  props:{
    item:
    {
      type: Object,
      required: true //if the type passed in isnt array doesnt wprl
    }
  },
  data(){
    return{
      show: false,
      showOverlay: false
    }
  }

}
</script>
<style scoped>
.box{
  filter: brightness(100%);
}
.box:hover
{
  filter: brightness(50%);
}


</style>
